import React from 'react'
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import EcoProButton from '../../../../components/shared/button/button';
import './SkipModal.css'
import { isDesktopApp } from '../../../../constants/AppMethod';
import { NATIVE_APP_SELECTION_ATTRIBUTE } from '../../../../constants/AppConstants';

const SkipModal = (props) => {
    const {modalState, toggleModal, handleBackBtn, handleContinueBtn} = props;
    const { t } = useTranslation(["translation"]);
    const isDesktopApplication = isDesktopApp();
  return (
    <div className="iprint-easysetup-modal-container">
        <Modal isOpen={modalState} toggle={() => toggleModal()} backdrop={true} size="lg" className= {
            `iprint-easysetup-modal 
            ${(!isDesktopApplication) && 'bmc-easysetup-modal'}`
        }>
            <ModalHeader className="body-medium-large">{t("EASY_SETUP_IPRINT.SKIP_NOW_MODAL.HEADER")}</ModalHeader>
            <ModalBody>
                <ul>
                    <li>{t("EASY_SETUP_IPRINT.SKIP_NOW_MODAL.POINT_1")}</li>
                    <li>{t("EASY_SETUP_IPRINT.SKIP_NOW_MODAL.POINT_2")}</li>
                    <li>{t("EASY_SETUP_IPRINT.SKIP_NOW_MODAL.POINT_3")}</li>
                </ul>
            </ModalBody>
            <ModalFooter className="easy-setup-footer">
                <div>
                    <EcoProButton cname="continue-btn" onBtnClick={() => handleContinueBtn(NATIVE_APP_SELECTION_ATTRIBUTE.SKIP)}>{t('EASY_SETUP_IPRINT.CONTINUE')}</EcoProButton>
                </div>
                <div>
                    <EcoProButton cname="back-btn" onBtnClick={() => handleBackBtn()}>{t('EASY_SETUP_IPRINT.BACK_BTN')}</EcoProButton>
                </div>
            </ModalFooter>
        </Modal>
    </div>
  )
}

export default SkipModal
